<template>
  <section ref="section">
    <svgWatermarkLogo class="sw" />
    <div class="container">
      <h2>이모티콘 지금 바로 써보기</h2>
      <p>마음에 드는 이모티콘을 눌러 입력해보세요.</p>

      <Demo ref="demo" />      
    </div>
  </section>
</template>

<script>
import {gsap, ScrollTrigger} from "gsap/all";
gsap.registerPlugin(ScrollTrigger)

import Demo from '@/components/demo/Demo'
import svgWatermarkLogo from '@/svg/svgWatermarkLogo.vue'
export default {
  mounted() {
    gsap.fromTo(this.$refs.demo.$el, {y: "100%"}, {
      y: 0,
      scrollTrigger: {
        scrub: 0.1,
        end: '+=120%',
        trigger: this.$refs.section,        
      }
    })
  },
  components: {
    Demo,
    svgWatermarkLogo
  }
}
</script>

<style lang="scss" scoped>
section {
  --title-font-size: 28px;
  --copy-font-size: 16px;
  padding: 70px 0 0;
  background-color: #F3F3F3;
  position: relative;
  z-index: 5;
  margin-bottom: -40px;
  @media screen and (max-width: 600px) {
    --title-font-size: 22px;
    --copy-font-size: 16px;
  }
}

h2 {
  font-size: var(--title-font-size);
  font-weight: 700;
  color: #171717;
  text-align: center;
  margin-bottom: 5px
}
 
p {
  font-weight: 500;
  font-size: var(--copy-font-size);
  color: #797B80;
  text-align: center;
}

.sw {
  position: absolute;
  top: 228px;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
  height: 250px;
  @media screen and (max-width: 1280px) {
    height: auto;
    width: calc(100% - var(--app-gutter-size) * 2); 
  }
  @media screen and (max-width: 600px) {
    transform: translate3d(-50%, -50%, 0);
  }
}


</style>